import { CARD_RADIUS_STYLES } from '@apps-common/config/styles'
import classNames from 'classnames'

export const SignalStrengthKpiCardSkeleton: React.FC = () => {
  return (
    <div
      className={classNames(
        'relative w-full flex flex-col bg-skeleton border border-skeleton-border px-4 py-4 h-[148px] animate-pulse',
        CARD_RADIUS_STYLES
      )}
    >
      <div className='w-full h-full flex flex-col items-center justify-center'>
        <div className='w-full flex'>
          <div className='relative rounded-3xl mx-auto bg-skeleton-hi p-4 min-w-[80%]'>
            <div className='absolute right-[-5px] top-[-5px] z-[2] w-[25px] h-[25px] rounded-full bg-surface-2'>
              <div className=' w-[25px] h-[25px] rounded-full bg-skeleton-hi'>
                <div className='w-[25px] h-[25px] rounded-full bg-skeleton-hi' />
              </div>
            </div>
            <div className='flex flex-col items-center justify-center gap-2 text-text'>
              <div className=' flex items-center justify-between rounded-full bg-skeleton-hi w-[60px] h-[27px]' />
              <div className='w-[63px] h-[18px] bg-skeleton-hi rounded-full' />
            </div>
          </div>
        </div>
        <div className='w-full flex items-center justify-between px-2 mt-2'>
          <div className='w-[61px] h-[21px] bg-skeleton-hi rounded-full' />
          <div className='flex items-center justify-center rounded-full bg-skeleton-hi w-[22px] h-[22px]' />
        </div>
      </div>
    </div>
  )
}
